// import Cedem from './Index.vue'
import Permissions from "../../models/Permissions";

const EmpresasRFB = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/EmpresasRFB",
    name: "EmpresasRFB",
    component: EmpresasRFB,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Empresas RFB",
      icon: "fa fa-files-o",
      group: "Auditoria",
      permissions,
    },
  },
];
